module.exports = __webpack_public_path__ + "static/img/imperium.c0e7a8b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imperium.gif
// module id = QfZh
// module chunks = 1